// extracted by mini-css-extract-plugin
module.exports = {"list":"data-list_list__2rNZV","show":"data-list_show__2hQTW","item":"data-list_item__1r89b","active":"data-list_active__2bEVi","empty":"data-list_empty__1wdnL"};